import React from 'react';

import logo from '../../assets/footer-logo.svg';
import { Container } from './styles';

const Footer: React.FC = () => {
  return (
    <Container>
      <p>
        Uma produção
        <img
          src={logo}
          alt="Wedo Afferolab"
          style={{ width: '66px', height: '12px' }}
        />
        | © 2020
      </p>
    </Container>
  );
};

export default Footer;
